import React from "react";
import { FiWifi, FiRefreshCw } from "react-icons/fi";
import logo from "./assets/hallef-logo-cropped.png";
import "./slow-network.css";

export default function SlowNetwork() {

  return (
    <main className="offline-page">
      <img className="offline-logo" src={logo} alt="Hallef Technologies" />
      <section className="offline-card" aria-labelledby="slow-network-title">
        <div className="offline-icon"><FiWifi aria-hidden="true" /></div>
        <p className="offline-eyebrow">LET'S GET THINGS MOVING</p>
        <h1 id="slow-network-title">Your network is slow</h1>
        <p className="offline-description">
          Things are taking a little longer than usual. Check your Wi-Fi or mobile data connection, then try again.
        </p>
        <button className="offline-retry" type="button" onClick={() => window.location.reload()}>
          <FiRefreshCw aria-hidden="true" /> Try again
        </button>
        <p className="offline-status">You can also switch to a stronger network.</p>
      </section>
      <p className="offline-footer">Hallef Technologies &middot; Keeping you connected</p>
    </main>
  );
}
